"use client";
import BreadcrumbItem from "./BreadCrumbItem";

export function Breadcrumb({ breadcrumbItems }: any) {
  return (
    <nav className="py-2 px-4 rounded-lg">
      <ol
        itemScope
        itemType="https://schema.org/BreadcrumbList"
        className="flex items-center flex-wrap gap-1"
      >
        {breadcrumbItems.map((item, index, array) => (
          <BreadcrumbItem
            {...item}
            index={index + 1}
            isLast={array.length - 1 === index}
            key={index}
          />
        ))}
      </ol>
    </nav>
  );
}
